import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "141",
  height: "39",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#7540EE",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      d: "M8.478 37.53a7.478 7.478 0 1 0 0-14.955 7.478 7.478 0 0 0 0 14.955Zm85.454 0a7.477 7.477 0 0 0 7.477-7.477 7.477 7.477 0 1 0-14.955 0 7.48 7.48 0 0 0 7.478 7.477Zm-42.01-21.575a7.478 7.478 0 1 0 0-14.955 7.478 7.478 0 0 0 0 14.955Zm80.55 0a7.478 7.478 0 1 0 0-14.955 7.478 7.478 0 0 0 0 14.955ZM100.155 26.57l25.928-14.827m-67.746.037 28.617 14.7m-71.664.192 29.884-14.84"
    }, null, -1)
  ]))]))
}
export default { render: render }